<template>
  <el-dialog
    :title="info.title"
    :visible.sync="dialogVisible"
    :width="info.width"
    id="confirmDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="confirmtips">
      <i class="el-icon-warning"></i>
      <span style="margin-left: 10px">{{info.content}}</span>
    </div>
    <div class="tipsColor">
        {{info.tips}}
    </div>
    <div style="text-align: center;margin-top: 40px">
      <el-button @click="close()" size="small">取消</el-button>
      <el-button @click="handleSubmit()" type="primary" size="small" v-preventClick>确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { setAdministrator } from "@/api/request";
export default {
  data() {
    return {
      dialogVisible: false,
      form: {},
      info: {}
    };
  },
  methods: {
    init(row,info) {
      this.dialogVisible = true;
      this.form = row;
      this.$nextTick(() => {
        this.info = info;
      });
    },
    handleSubmit () {
        let characterRole = this.info.title == '设为管理员' ? 2 : 3
        setAdministrator({
            clientId: this.form.clientId,
            characterRole: characterRole,
            teamId: this.form.teamId
        }).then(res=> {
            this.dialogVisible = false
            this.$emit('back')
            this.$message.success("操作成功");
        })
    },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style>
#confirmDialog .el-dialog__body {
    padding: 20px;
}
</style>
<style scoped>
.el-icon-warning {
    font-size: 30px;
    color: #E6A23C;
}
.tipsColor {
    margin-top: 10px;
    width: 100%;
    text-align: center;
    color: #E6A23C;
}
.confirmtips {
    width: 100%;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    font-size: 16px;
}
</style>